import Pagination from 'react-bootstrap/Pagination'

export const DataPagination = ({ totalResults, onPageNumberClick, page, paginationSeedNumber=100, numberOfResultsPages }) => {

    return <div className='d-flex flex-column align-items-center w-fit'>
        <div>
            Showing&nbsp;
            { Math.min(1 * (page * paginationSeedNumber) + 1, totalResults).toLocaleString() }{ " " }
            { totalResults !== 0 &&
                <>
                    to&nbsp;
                    { Math.min(
                        totalResults,
                        (page + 1) * paginationSeedNumber
                    ).toLocaleString() }&nbsp;
                    of { totalResults.toLocaleString() }
                </>
            }&nbsp;
            items
        </div>
        {
            totalResults > paginationSeedNumber && numberOfResultsPages &&
            <Pagination>
                {
                    page !== 0
                    && <Pagination.Item onClick={ () => onPageNumberClick(page - 1) }>
                        <i className='fi-chevron-left me-sm-2'></i>
                        <span className='d-none d-sm-inline'>Prev</span>
                    </Pagination.Item>
                }

                {
                    numberOfResultsPages <= 7
                        ? <>
                            {
                                (
                                    () => {
                                        let paginationItems = [];
                                        for (let i = 0; i < numberOfResultsPages; i++) {
                                            paginationItems.push(
                                                <Pagination.Item key={ i } active={ i === page } onClick={ () => onPageNumberClick(i) }>
                                                    { i + 1 }
                                                </Pagination.Item>
                                            )
                                        }
                                        return paginationItems
                                    }
                                ) ()
                            }
                        </>
                        : <>
                            { page > 3 && (
                                <>
                                    <Pagination.Item active={ page === 1 } onClick={ () => onPageNumberClick(0) }>
                                        1
                                    </Pagination.Item>
                                    { page > 4 && <Pagination.Ellipsis /> }
                                </>
                            ) }
                            { 
                                (
                                    () => {
                                        let paginationItems = [];

                                        for (let i = 0; i < numberOfResultsPages; i++) {
                                            if (
                                                i >= Math.max(0, page - 3) &&
                                                i <= Math.min(numberOfResultsPages, page + 3)
                                            ) {
                                                paginationItems.push(
                                                    <Pagination.Item key={ i } active={ i === page } onClick={ () => onPageNumberClick(i) }>
                                                        { i + 1 }
                                                    </Pagination.Item>
                                                )
                                            }
                                        }
                                        return paginationItems
                                    }
                                ) ()
                            }
                            { page < numberOfResultsPages - 4 && (
                                <>
                                    { page + 3 < numberOfResultsPages - 2 && (
                                        <Pagination.Ellipsis />
                                    ) }
                                    <Pagination.Item active={ page === numberOfResultsPages } onClick={ () => onPageNumberClick(numberOfResultsPages - 1) }>
                                        { numberOfResultsPages }
                                    </Pagination.Item>
                                </>
                            ) }
                        </>
                }
                {
                    (page + 1) !== numberOfResultsPages
                    && <Pagination.Item onClick={ () => onPageNumberClick(page + 1) }>
                    <span className='d-none d-sm-inline'>Next</span>
                    <i className='fi-chevron-right ms-sm-2'></i>
                </Pagination.Item> 
                }
            </Pagination>
        }
    </div>
}